import { Controller } from "@hotwired/stimulus"

// タスク完了トグル。一覧の tr に打ち消し線を付ける。tr が無い画面では何もしない。
export default class extends Controller {
  static values = { completed: { type: Boolean, default: false } }

  connect() {
    const row = this.element.closest("tr")
    if (!row) return
    row.classList.toggle("break-line", this.completedValue)
  }
}
